module.exports = __webpack_public_path__ + "static/assets/d6e3c6d41907f2b4cd4d4112115c6a96.png";